import React from 'react';
import { Flex, Heading, VStack, Spacer } from '@chakra-ui/layout';
import { useColorMode } from '@chakra-ui/color-mode';
import { IconButton } from '@chakra-ui/button';
import { FaSun, FaMoon, FaInstagram, FaGithub, FaLinkedin } from 'react-icons/fa'
import Header from './components/Header';
import Social from './components/Social';
import Profile from './components/Profile'


function App() {
const { colorMode, toggleColorMode } = useColorMode();
const isDark = colorMode ==="dark";

  return (
    <VStack p={5}>
      <Flex w="100%" >
        <Heading ml="8" size="md" fontWeight="semibold" color="cyan.400" >yasarrkhan</Heading>

        <Spacer></Spacer>
        <IconButton ml={2} icon={<FaLinkedin />} isRound='true' onClick={() => window.open("https://linkedin.com/in/yasarrkhan")}></IconButton>
        <IconButton ml={2} icon={<FaInstagram />} isRound='true' onClick={() => window.open("https://instagram.com/yasarrkhan")}></IconButton>
        <IconButton ml={2} icon={<FaGithub />} isRound='true' onClick={() => window.open("https://github.com/khanyasar022")}></IconButton>
        <IconButton ml={8} icon={isDark ? <FaSun /> : <FaMoon />} isRound='true' onClick={toggleColorMode}></IconButton>
      </Flex>
      <Header></Header>
      <Social></Social>
      <Profile></Profile>
    </VStack>
  );
}

export default App;
